import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import { useProductDummyRoomFormModelContext } from "../../../../context";

export const useDummyRoomPlanConnection = () => {
	const { viewModel, onSetViewModel, queryData } = useProductDummyRoomFormModelContext();
	const { availablePlanIDs } = viewModel;
	const { planNameAndIDOptions } = queryData.connection;

	return useConnection<"availablePlanIDs">({
		availableItemIDs: availablePlanIDs,
		nameAndIDOptions: planNameAndIDOptions,
		keyOfValue: "availablePlanIDs",
		onSetViewModel,
	});
};
